<div>

  <input
  class="todo-input"
  #inputElementRef
  [value]=""
  placeholder="Add an item!"
  onfocus="this.value = ''"
  minlength="1"
  (keyup.enter)="submitValue($event.target.value)">

<button class="btn" (click)="submitValue(inputElementRef.value)">
  Save
</button>
</div>
